import { render, staticRenderFns } from "./deductionRecord.vue?vue&type=template&id=8d48c480&scoped=true"
import script from "./deductionRecord.vue?vue&type=script&lang=js"
export * from "./deductionRecord.vue?vue&type=script&lang=js"
import style0 from "./deductionRecord.vue?vue&type=style&index=0&id=8d48c480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d48c480",
  null
  
)

export default component.exports